import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { FeedbackModal } from '../ui/diary/FeedbackModal';

interface MountOptions {
  /** Unique ID for this prompt (used for session storage) */
  promptId: string;
  /** URL to submit feedback */
  feedbackUrl: string;
  /** URL to postpone feedback */
  postponeUrl: string;
  /** Google Play Store URL for reviews */
  googlePlayUrl: string;
  /** CSRF token for API requests */
  csrfToken: string;
  /** Translations for modal content */
  translations: {
    title: string;
    subtitle: string;
    ratingQuestion: string;
    pleaseSelectRating: string;
    highRatingTitle: string;
    highRatingText: string;
    reviewButton: string;
    commentsPlaceholder: string;
    commentsHelp: string;
    submit: string;
    postpone: string;
  };
}

// Store root reference for cleanup
let root: Root | null = null;

export function mountFeedbackModal(container: HTMLElement, options: MountOptions): void {
  // Clean up previous root if it exists
  if (root) {
    root.unmount();
  }

  root = createRoot(container);
  root.render(
    <FeedbackModal
      promptId={options.promptId}
      feedbackUrl={options.feedbackUrl}
      postponeUrl={options.postponeUrl}
      googlePlayUrl={options.googlePlayUrl}
      csrfToken={options.csrfToken}
      translations={options.translations}
    />
  );
}

export function unmountFeedbackModal(): void {
  if (root) {
    root.unmount();
    root = null;
  }
}
